import {
  clearLoginNoticeDismissal,
  clearLoginNotice,
  clearLoginNoticeForDifferentUser,
  dismissLoginNotice,
  getUserId,
  isLoginNoticeDismissedForUser,
  setLoginNoticeForUser
} from '~/utils/accountSharingLoginNotice'

export const state = () => ({})
export const getters = {}
export const mutations = {}

function refreshUsetifulTags(context, shouldRefresh) {
  if (
    shouldRefresh &&
    context.$usetiful &&
    typeof context.$usetiful.refreshTags === 'function'
  ) {
    context.$usetiful.refreshTags()
  }
}

export const actions = {
  async refresh() {
    let storageChanged = false

    if (!process.client || !this.$auth || !this.$auth.loggedIn) {
      storageChanged = clearLoginNotice()
      refreshUsetifulTags(this, storageChanged)
      return storageChanged
    }

    const userId = getUserId(this.$auth && this.$auth.user)
    if (!userId) {
      storageChanged = clearLoginNotice()
      refreshUsetifulTags(this, storageChanged)
      return storageChanged
    }

    storageChanged = clearLoginNoticeForDifferentUser(userId)

    if (isLoginNoticeDismissedForUser(userId)) {
      storageChanged = clearLoginNotice() || storageChanged
      refreshUsetifulTags(this, storageChanged)
      return storageChanged
    }

    try {
      const response = await this.$axios.$get(
        `${process.env.IMPORTSCAN_AWS_URL}/zoho/account-status`,
        { params: { _: Date.now() } }
      )

      if (response && response.showLoginNotice === true) {
        storageChanged = setLoginNoticeForUser(userId) || storageChanged
      } else {
        storageChanged = clearLoginNotice() || storageChanged
      }
    } catch (error) {
      storageChanged = clearLoginNotice() || storageChanged
    }

    refreshUsetifulTags(this, storageChanged)
    return storageChanged
  },

  dismiss() {
    const storageChanged = dismissLoginNotice(
      getUserId(this.$auth && this.$auth.user)
    )
    refreshUsetifulTags(this, storageChanged)

    return storageChanged
  },

  clearLoginNoticeStorage() {
    const storageChanged = clearLoginNotice()
    clearLoginNoticeDismissal()
    refreshUsetifulTags(this, storageChanged)

    return storageChanged
  }
}
